export const basic = {
    required: true,
    pattern: {
        value: /^[a-zA-Z0-9_{}/]*$/,
        message: 'Invalid field format'
    }
}

export const timeoutMilliseconds = {
    required: false,
    pattern: {
        value: /^(100000|[1-9][0-9]{0,4})$/,
        message: "This must be a number between 1 and 100000",
    }
}

export const wholeNumber = {
    required: false,
    pattern: {
        value: /^[0-9]*$/,
        message: "This must be a whole number",
    }
}

export const variableBasic = {
    required: true,
    validate: {
        notStartWithNumber: value => /^[^\d]/.test(value) || 'Cannot start with a number',
        onlyAllowedChars: value => /^[a-zA-Z0-9_{}/]*$/.test(value) || 'Contains invalid characters'
    }
}

export const basicFolderFileName = {
    required: true,
    pattern: /^[a-zA-Z0-9_{}/.]*$/
}

export const assetFileName = {
    required: true,
    pattern: /^[a-zA-Z0-9_]*$/, // Allows only letters, numbers, and underscores
};


export const validationMessages = {
    required: 'This field cannot be empty',
    pattern: 'This field cannot contain special characters or white spaces'
}

export const requiredOnly = {
    required: true,
}

export const requiredOnlyMessage = {
    required: 'This field cannot be empty',
}

export const numberOnly = {
    pattern: /^[0-9]*$/
}

export const numberOnlyMessage = {
    pattern: 'This field cannot contain alphabets, special characters or white spaces'
}

export const patternOnly = {
    pattern: /^[a-zA-Z0-9_{}/]*$/
}

export const patternOnlyMessage = {
    pattern: 'This field cannot contain special characters or white spaces'
}

export const numberCheck = (string) => {
    const check = new RegExp(/^[0-9]*$/).test(string);
    if (check === false) return false;
    else return true
}

export const host = {
    pattern: /^[a-zA-Z0-9_{}.:/]*$/
}

export const integerFloatStringCheck = (value) => {


    if (new RegExp(/^\-?[0-9]\d*(\.\d*)?$/).test(value) === true) return true;

    else if (new RegExp(/^[a-zA-Z/-_]/).test(value) === true) return true;

    else if(value === "") return true;

    else if (new RegExp(/^(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}$/).test(value) === true) return true;
    
    else return false;

}

export const integerFloatCheck = (value) => {

    if (new RegExp(/^\-?[0-9]\d*(\.\d*)?$/).test(value) === true) return true;

    else if (value === "") return true;

    return false;

}

export const positiveNegativeNumbers = (value) => {

    if (new RegExp(/^\-?[0-9]\d*(\.\d*)?$/).test(value) === true) return true;

    else if (value === "") return true;

    else return false;

}

export const typeSpecificValidation = (type) => (value) => {
    let check = true

    const numberOnlyTypes = ['gauge', 'DOUBLE', 'FLOAT', 'double']

    if (numberOnlyTypes.includes(type)) {
        check = positiveNegativeNumbers(value);
    } else {
        check = integerFloatStringCheck(value);
    }
    return check
}

export const validateRslice = (myString) => {
    const regex = new RegExp(/^[a-zA-Z0-9][a-zA-Z0-9_.]*[a-zA-Z0-9]$/);
    if (myString == "") {
        return false;
    } else if (regex.test(myString)) {
        return true;
    } else {
        return false;
    }
}


export const validateIpOrDNS = (value) => {
    if (!value) return false;
  
    // Strict IPv4 pattern
    const ipv4Pattern = /^(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}$/;
  
    // Strict DNS/hostname pattern (RFC 1123 compliant)
    const dnsPattern = /^(?=.{1,253}$)(?!-)(?:[A-Za-z0-9-]{1,63}\.)+[A-Za-z]{2,63}$/;
  
    return ipv4Pattern.test(value) || dnsPattern.test(value);
};

export const validateEmail = (email) => {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

export const wholeNumberValidation = (depedency) => (value) => {

    const positiveWholeNumber = new RegExp(/^[1-9][0-9]*$/).test(value);

    if ((depedency === "" || depedency === undefined) && (value === "" || value === undefined)) return true;

    else if (positiveWholeNumber === false) return false;

    else if ((depedency !== "" || depedency !== undefined) && value === "") return false;

    else return true

}

export const sectionNameValidation = (value, names) => {
    try {

    const basic = new RegExp(/^[a-zA-Z0-9_]*$/).test(value);

    const schemaNames = names.map(item => {
        const name = item.toLowerCase()
        return name;
    })

    const givenName = value !== undefined ? value.toLowerCase() : ""

    if (value === "" || value === null) return "This field cannot be empty"

    else if (basic === false) return "This field cannot contain special characters or white spaces"

    else if (schemaNames.includes(givenName)) {
        // console.log("schema names and givenName", {schemaNames, givenName})

        return "The given name exists"
    }
    return true;
    } catch (error) {
        console.error(`Section name vaildation failed. Value: '${value}'. ${error}`);
        console.log({value, names});
        return "";
    }
}

export const uiTypeValidation = (value) => {

    if (value === "select" || value === null || value === undefined) {
        return "Must be a valid type";
    } else {
        return true;
    }
}

export const uiHeightWidthValidation = (value) => {
    const isNumeric = new RegExp(/^[1-9]*$/).test(value);
    if (value === null || value === '') {
        return "This field cannot be empty";
    } else if (!isNumeric) {
        return "This field must be valid number";
    } else {
        return true;
    }
}

export const noSpecialCharExceptFowardSlash = (value) => {
    const specialChar = new RegExp(/[!$%^&*()_+|~=`{}\[\]:";'<>?,.-]/).test(value);
    if (specialChar) return false;

    return true;
};

export const duplicateEventName = ({ allEvents, allTransactionsList, selectedTransaction, clusterlets, selectedSrc, element }) => (name) => {
    try {
    let status = true

    const allEventsWithTransactionId = JSON.parse(JSON.stringify(allEvents)).map(event => {
        const transaction = allTransactionsList.find(item => item.events.map(e => e.id).includes(event.id))
        event.transaction = transaction.id
        return event
    })

    const duplicateEvents = allEventsWithTransactionId.filter(item =>
        item.name === name &&
        item.id !== element.id &&
        item.transaction !== selectedTransaction.id
    )

    const duplicate = duplicateEvents.find(duplicateEvent => {

        const duplicateEventSource = clusterlets.find(item => item.id === duplicateEvent.src)

        const source = clusterlets.find(item => item.id === selectedSrc)

        if (duplicateEventSource.type === 1 && source.type === 1) {
            return duplicateEvent
        }
    })

    if (duplicate !== undefined) return false;

    return status;

    } catch (error) {
        console.error(`Validating duplicate event name failed. ${error}`);
        console.log({allEvents, selectedTransaction});
        return false;
    }
}

function validateQuerayParameterKey(key) {
    const regex = /^[a-zA-Z0-9_-]+$/;
    return regex.test(key);
  }

function validateQuerayParameterValue(value) {
    return value.trim().length > 0; // simple check, can extend
}

export const validateQuerayParametersInHyperlink = (queryParameters, errors, schemaPath) => {
    try {
    if(queryParameters?.length === 1){
        const {Key, Value} = queryParameters[0];
        if(Key !== "" || Value !== ""){
          if (!validateQuerayParameterKey(Key)) {
            errors.push({
              path: `${schemaPath}.0`,
              property: 'format',
              message: `Invalid name: ${Key}. Only letters, numbers, _ and - allowed.`,
              table: true
            })
          }else{
            if (!validateQuerayParameterValue(Value)) {
              errors.push({
                path: `${schemaPath}.0`,
                property: 'format',
                message: `Value for ${Key} cannot be empty.`,
                table: true
              })
            }
          }  
        }
    }else{
      queryParameters?.forEach((param, index) => {
        const {Key, Value} = param;
        if (!validateQuerayParameterKey(Key)) {
          errors.push({
            path: `${schemaPath}.${index}`,
            property: 'format',
            message: `Invalid name: ${Key}. Only letters, numbers, _ and - allowed.`,
            table: true
          })
        }else{
          if (!validateQuerayParameterValue(Value)) {
            errors.push({
              path: `${schemaPath}.${index}`,
              property: 'format',
              message: `Value for ${Key} cannot be empty.`,
              table: true
            })
          }
        }
      })

    }
    
    return errors;
    } catch (error) {
        console.error(`Validating query parameters for hyperlink failed. ${error}`);
        console.log({queryParameters, errors, schemaPath});
        return [];
    }
}
